/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTrianglePlusEmpty: {
  name: 'triangle-plus-empty';
  data: string;
} = {
  name: 'triangle-plus-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.73 2.994c-.77-1.33-2.69-1.33-3.46 0L1.003 18.998C.232 20.33 1.194 22 2.734 22h18.532c1.54 0 2.502-1.669 1.73-3.002L13.731 2.994ZM12 3.996 21.265 20H2.735L12 3.996ZM12 12a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
